import _extends from "@babel/runtime/helpers/esm/extends";
import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import { ApolloLink, InMemoryCache, Observable } from '@apollo/client/core';
import { openDB } from 'idb';
const shouldPersist = operation => operation.getContext().offline;
class OfflineLinkInternal extends ApolloLink {
  constructor(possibleTypes, getDb) {
    super();
    this.offlineCache = void 0;
    this.possibleTypes = void 0;
    this.getDb = void 0;
    this.possibleTypes = possibleTypes;
    this.offlineCache = new InMemoryCache(this.possibleTypes);
    this.getDb = getDb;
    getDb().then(db => db.get('entries', 'cache').then(data => this.offlineCache.restore(data)));
  }
  getCache({
    query,
    variables
  }) {
    try {
      return this.offlineCache.readQuery({
        query: query,
        variables: variables
      });
    } catch (e) {
      return null;
    }
  }
  syncDatabase() {
    var _this = this;
    return _asyncToGenerator(function* () {
      const db = yield _this.getDb();
      db.put('entries', _this.offlineCache.extract(), 'cache');
    })();
  }
  request(operation, forward) {
    const persist = shouldPersist(operation);
    const forwardAndStore = op => {
      return forward(op).map(result => {
        this.offlineCache.writeQuery({
          query: operation.query,
          variables: operation.variables,
          data: result.data
        });
        this.syncDatabase();
        return result;
      });
    };
    const cache = this.getCache(operation);
    if (!persist && !cache) {
      // Operation doesn't have anything in cache and should not be persisted
      return forward(operation);
    }
    if (cache) {
      // Operation is in cache, let's return it and refresh cache
      forwardAndStore(operation).subscribe(() => void 0);
      return Observable.of({
        data: cache
      });
    }
    return forwardAndStore(operation);
  }

  /**
   * Will clear the cache from all the entities that are not needed to answer the `queriedToKeep`.
   * Note that this method is network safe, it will not try to fetch a query if the cache cannot answer it.
   */
  gc(queriesToKeep) {
    // Create a brand new cache that will host all the queries we want to save from garbage collection
    const tmpCache = new InMemoryCache(this.possibleTypes);

    // Re query all the operations needed against the old cache
    queriesToKeep.forEach(queryOptions => {
      const result = this.getCache(queryOptions);
      if (result) {
        tmpCache.writeQuery({
          query: queryOptions.query,
          variables: queryOptions.variables,
          data: result
        });
      }
    });

    // Drop the old offlineCache and replace it with the freshly hydrated one
    this.offlineCache = tmpCache;
    this.syncDatabase();
  }
}
const defaultParams = {
  possibleTypes: undefined,
  onDbUpgrade: () => void 0
};
export function createOfflineLink(params) {
  let dbInstance;
  const {
    possibleTypes,
    onDbUpgrade
  } = _extends({}, defaultParams, params);
  const getDb = () => {
    dbInstance = dbInstance || openDB('dzgraphcache', 2, {
      upgrade: (database, oldVersion, newVersion) => {
        switch (oldVersion) {
          case 0:
            database.createObjectStore('entries');
            break;
          default:
        }
        onDbUpgrade(oldVersion, newVersion);
      }
    });
    return dbInstance;
  };
  return new OfflineLinkInternal(possibleTypes, getDb);
}
//# sourceMappingURL=offlineLink.js.map